export default "__VITE_ASSET__C6tbpX2Q__"